// extracted by mini-css-extract-plugin
export var box = "_9v-1";
export var checked = "_9v-2";
export var descriptionSpacer = "_9v-9";
export var disabled = "_9v-3";
export var icon = "_9v-6";
export var input = "_9v-0";
export var labelSpacer = "_9v-8";
export var medium = "_9v-5";
export var small = "_9v-4";
export var text = "_9v-7";